import {
  IForwardToLoadingStates,
  IRecentContacts,
} from "@home-health-notify/domain";
import SearchIcon from "@mui/icons-material/Search";
import { Typography } from "@mui/material";
import { useTranslation } from "hhn-commons";
import React from "react";
import EmptyRecordView from "../../../common/EmptyRecordView";
import ProgressLoader from "../../../loader/ProgressLoader";
import {
  ForwardToIdleStateSubtext,
  ForwardToIdleStateWrapper,
  MessageItemModalListWrapper,
} from "../MessagePanel.style";
import ForwardToListItem from "./ForwardToListItem";

interface ForwardToListProps {
  isLoading: IForwardToLoadingStates;
  forwardToList: IRecentContacts[];
  selectedContactsToForwardTo: IRecentContacts[];
  handleContactSelected: (selectedContact: IRecentContacts) => void;
  hasSearched: boolean;
  supportsMrnSearch?: boolean;
}

function ForwardToList({
  isLoading,
  forwardToList,
  selectedContactsToForwardTo,
  handleContactSelected,
  hasSearched,
  supportsMrnSearch,
}: ForwardToListProps) {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const isBusy =
    isLoading.isTabListLoading ||
    isLoading.isSearchLoading ||
    isLoading.isNextPageLoading;

  return (
    <MessageItemModalListWrapper data-testid="forward-to-list">
      {forwardToList.length > 0 &&
        (!isLoading.isTabListLoading || isLoading.isNextPageLoading) && (
          <>
            {forwardToList.map((contact: IRecentContacts) => {
              return (
                <ForwardToListItem
                  key={contact.id}
                  contact={contact}
                  selectedContactsToForwardTo={selectedContactsToForwardTo}
                  handleContactSelected={handleContactSelected}
                />
              );
            })}
          </>
        )}
      {forwardToList.length === 0 && !hasSearched && !isBusy && (
        <ForwardToIdleStateWrapper data-testid="forward-to-idle-state">
          <SearchIcon fontSize="large" color="disabled" />
          <Typography variant="subtitle1">
            {tNs("forwardTo.searchToForward")}
          </Typography>
          <ForwardToIdleStateSubtext variant="body2">
            {tNs(
              supportsMrnSearch
                ? "forwardTo.searchToForwardHintMrn"
                : "forwardTo.searchToForwardHint",
            )}
          </ForwardToIdleStateSubtext>
        </ForwardToIdleStateWrapper>
      )}
      {forwardToList.length === 0 && hasSearched && !isBusy && (
        <EmptyRecordView emptyMessage={tNs("forwardTo.noContactsFound")} />
      )}
      {isLoading.isNextPageLoading && (
        <ProgressLoader
          label={tNs("forwardTo.loadingContacts")}
          style={{
            height: "auto",
            marginTop: "9px",
          }}
        />
      )}
      {isLoading.isTabListLoading && !isLoading.isNextPageLoading && (
        <ProgressLoader
          label={tNs("forwardTo.loadingContacts")}
          style={{
            zIndex: 1,
            position: "absolute",
            inset: "0 0 0 0",
            top: 48,
          }}
        />
      )}
    </MessageItemModalListWrapper>
  );
}

export default ForwardToList;
